import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { AssetContainer } from '~/techstyle-shared/react-assets';
import { useBreakpoint } from '~/techstyle-shared/react-components';
import { useIntl } from '~/techstyle-shared/react-intl';

import CloseButton from '../CloseButton';
import FableticsModal from '../FableticsModal';

// Modal does NOT save customer information, purely UI until inventory replenishes

const modalDialogStyle = css`
  width: 622px;
  overflow: hidden;
  border-radius: 5px;
`;

const transitionProps = {
  enter: { opacity: 1, transform: 'scale(1, 1)' },
  from: { opacity: 0, transform: 'scale(0.5, 0.5)' },
  leave: { opacity: 0, transform: 'scale(0.5, 0.5)' },
};

const contentWrapperStyles = css`
  display: block;
`;

const ModalCloseButton = styled(CloseButton)`
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 16px;
`;

const ModalContent = styled.div`
  cursor: pointer;
`;

const BackgroundImage = styled(AssetContainer)`
  width: 832px;
  max-width: 100%;
  height: 100%;

  & > picture {
    display: block;
    height: 100%;

    & > img {
      height: 100%;
    }
  }
`;

const ScrubsWaitlistModal = ({
  isOpen,
  onExit,
  desktopAssetContainer = 'fake_waitlist_popup_desktop',
  mobileAssetContainer = 'fake_waitlist_popup_mobile',
}) => {
  const intl = useIntl();
  const { isMobile } = useBreakpoint();
  const assetContainer = isMobile
    ? mobileAssetContainer
    : desktopAssetContainer;
  const closeLabel = intl.formatMessage({
    id: 'global_cta.close',
    defaultMessage: 'Close',
  });
  const modalTitle = intl.formatMessage({
    id: 'grid.scrubs_waitlist_modal_title',
    defaultMessage: 'scrubs waitlist modal',
  });

  return (
    <FableticsModal
      isOpen={isOpen}
      onExit={onExit}
      dialogStyle={modalDialogStyle}
      overlayClickExits
      showCloseButton
      contentWrapperStyles={contentWrapperStyles}
      closeButton={<ModalCloseButton aria-label={closeLabel} />}
      transitionEnter={transitionProps.enter}
      transitionFrom={transitionProps.from}
      transitionLeave={transitionProps.leave}
      title={modalTitle}
      aria-label={modalTitle}
    >
      <ModalContent onClick={() => onExit()}>
        <BackgroundImage name={assetContainer} />
      </ModalContent>
    </FableticsModal>
  );
};

ScrubsWaitlistModal.propTypes = {
  /**
   * AssetContainer name to be used for desktop
   */
  desktopAssetContainer: PropTypes.string,
  isOpen: PropTypes.bool,
  /**
   * AssetContainer name to be used for mobile devices
   */
  mobileAssetContainer: PropTypes.string,
  onExit: PropTypes.func,
};

export default ScrubsWaitlistModal;
